import React from "react";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/browser";

class SentryErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    if (!error) {
      return;
    }

    Sentry.withScope(scope => {
      scope.setTag("source", "react.error-boundary");
      scope.setExtra("componentStack", errorInfo && errorInfo.componentStack);
      Sentry.captureException(error);
    });
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

SentryErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default SentryErrorBoundary;
